export const TEST_ID_MOBILE_SUMMARY_HOTEL_NIGHTS_HOTEL =
  'mobile-summary-hotel-nights-hotel';
